import tw from "twin.macro";
import { Link } from "react-router-dom";
import { useCartContext } from "context/UseCartContext";
import {
  useNavigate,
} from "react-router-dom";
import { memo, useEffect, useState } from "react";
import { getCustomerId } from "utility/HeaderConfig";
import zingerPlaystore from '../../images/Zinger web Image QR.png'
import SocialMedia from "components/SocialMedia";
import { ECommerce } from "api/AppConfigApi";

const ColumnHeading = tw.h5`uppercase font-bold tracking-widest m-0`;
const LinkList = tw.ul`my-5 font-medium p-0`;
const LinkListItem = tw.li`mt-3`;
const SocialLinksContainer = tw.div`flex mb-5 duration-500 `;

function Footer({ branch, configImages }) {
  const { dispatch } = useCartContext();
  const history = useNavigate();
  const [gatwayIcon, setgatwayIcon] = useState([]);
  const [qrCode, setQrcode] = useState([]);
  const [media, setMedia] = useState([]);

  useEffect(() => {
    getBanner();
    socialMedia();
    //eslint-disable-next-line
  }, []);

  const socialMedia = () => {
    let filter = "social_media_config";
    ECommerce(filter).then((data) => {
      let SOCIALMEDIA = JSON.parse(data.response.moduleField);
      setMedia(SOCIALMEDIA);
    });
  };

  const getBanner = () => {
    configImages.PGIMAGES &&
      configImages.PGIMAGES.forEach((data) => {
        if (data.key === "paymentGatway") {
          setgatwayIcon(data.value);
        }
      });

    configImages.MOBILE_APP_QR &&
      configImages.MOBILE_APP_QR.forEach((data) => {
        if (data.key === "qrCode") {
          setQrcode(data.value);
        }
      });
  };

  const handleClick = () => {

    if (getCustomerId() === undefined) {
      dispatch({ type: "MODAL", payload: "login" });
    } else {
      history("/ProductOrderDetails")
    }

  };

  return (
    <>
      <footer className="ptSans" tw=" bg-cover bg-no-repeat">
        <div className="container">
          <div className="row m-auto" tw="py-16">
            <div className="col-6 col-lg-3 col-md-4">
              <ColumnHeading>Policies</ColumnHeading>
              <LinkList>
                <LinkListItem>
                  <Link
                    to="TermsConditions"
                    tw="no-underline duration-500 hocus:px-1 pb-1 text-gray-900 hover:text-custom-100"
                  >
                    Terms and Conditions
                  </Link>
                </LinkListItem>
                <LinkListItem>
                  <Link
                    to="PrivacyPolicy"
                    tw="no-underline hocus:px-1 duration-500  pb-1 text-gray-900 hover:text-custom-100"
                  >
                    Privacy Policy
                  </Link>
                </LinkListItem>
                <LinkListItem>
                  <Link
                    to="ShippingPolicy"
                    tw="no-underline hocus:px-1 duration-500  pb-1 text-gray-900 hover:text-custom-100"
                  >
                    Shipping Policy
                  </Link>
                </LinkListItem>
                <LinkListItem>
                  <Link
                    to="RefundPolicy"
                    tw="no-underline hocus:px-1 duration-500  pb-1 text-gray-900 hover:text-custom-100"
                  >
                    Refund Policy
                  </Link>
                </LinkListItem>
              </LinkList>
            </div>
            <div className="col-6 col-lg-3 col-md-4">
              <ColumnHeading>Quick Links</ColumnHeading>
              <LinkList>
                <LinkListItem>
                  <Link
                    to="/"
                    tw="no-underline hocus:px-1 pb-1 duration-500  text-gray-900 hover:text-custom-100"
                  >
                    Home
                  </Link>
                </LinkListItem>
                <LinkListItem>
                  <Link
                    to="About"
                    tw="no-underline hocus:px-1 pb-1 duration-500  text-gray-900 hover:text-custom-100"
                  >
                    About
                  </Link>
                </LinkListItem>
                <LinkListItem>
                  <Link
                    to="ProductList"
                    tw="no-underline hocus:px-1 pb-1 duration-500  text-gray-900 hover:text-custom-100"
                  >
                    Product
                  </Link>
                </LinkListItem>
                {/* <LinkListItem>
                  <Link
                    to="NewArrivals"
                    tw="no-underline hocus:px-1 pb-1 duration-500  text-gray-900 hover:text-custom-100"
                  >
                    New Arrivals
                  </Link>
                </LinkListItem> */}
                {/* <LinkListItem>
                  <Link
                    to="MostLiked"
                    tw="no-underline hocus:px-1 pb-1 duration-500  text-gray-900 hover:text-custom-100"
                  >
                    Most Liked{" "}
                  </Link>
                </LinkListItem> */}
                {/* <LinkListItem>
                  <Link
                    to="ReferralPoints"
                    tw="no-underline hocus:px-1 pb-1 duration-500  text-gray-900 hover:text-custom-100"
                  >
                    Referral Points{" "}
                  </Link>
                </LinkListItem>
                <LinkListItem>
                  <Link
                    to="#"
                    onClick={handleClick}
                    tw="no-underline hocus:px-1 pb-1 duration-500  text-gray-900 hover:text-custom-100"
                  >
                    Product Order Details{" "}
                  </Link>
                </LinkListItem> */}
              </LinkList>
            </div>

            <div className="col-6 col-lg-3 col-md-4">
              <ColumnHeading>Contact Us</ColumnHeading>
              <LinkList>
                <Link
                  to="Contact"
                  tw="no-underline hocus:px-1 pb-1 duration-500  text-gray-900 hover:text-custom-100"
                >
                  <SocialLinksContainer>
                    <i className="bi bi-pin-map" tw="text-2xl text-black"></i>
                    <div tw="ml-4 mb-0">
                      <p tw="m-0">
                        {Object.keys(branch).length > 0 && (
                          <>
                            {' '}{branch.branchAddress.address1}, {branch.branchAddress.address2},{' '}
                            {branch.branchAddress.talukName}, {branch.branchAddress.districtName},{' '} 
                            {branch.branchAddress.stateName}, {branch.branchAddress.pincodeNumber}
                          </>
                        )}
                      </p>
                      <b className="mb-0"><i className="bi bi-arrow-right-short"></i> Our Branch</b>
                    </div>
                  </SocialLinksContainer>
                </Link>
                <SocialLinksContainer>
                  <i className="bi bi-telephone" tw="text-2xl text-black"></i>
                  <p tw="ml-4 mb-0">+91 {branch.mobile}</p>
                </SocialLinksContainer>
                <SocialLinksContainer>
                  <i
                    className="bi bi-envelope-paper"
                    tw="text-2xl text-black"
                  ></i>
                  <a
                    href="mailto:info@zinger.co.in"
                    tw="ml-4 mb-0 no-underline text-gray-900 hover:text-custom-100"
                  >
                    {branch.email || 'jaibssaj@gmail.com'}
                  </a>
                </SocialLinksContainer>
              </LinkList>
            </div>

            {/* <div className="col-12 col-md-6 col-lg-3 mb-4">
              <ColumnHeading>Follow Us</ColumnHeading>
              <div
                className="d-flex flex-wrap align-items-center"
                style={{ fontSize: "28px", gap: "15px" }} >
                {media.map((data, index) => (
                  <a
                    href={data.value}
                    target="_blank"
                    rel="noopener noreferrer"
                    key={index}
                    style={{ color: "black" }}
                  >
                    <i className={`bi bi-${data.key?.toLowerCase()}`} style={{ fontSize: "28px" }}></i>
                  </a>
                ))}
              </div>
               <a
                href="https://play.google.com/store/apps/dev?id=6531507115281063048"
                target="_blank"
                rel="noreferrer"
              >
                <img src={zingerPlaystore} className="w-100" alt="QR Code" />
              </a>
            </div> */}

          </div>
          <div className="row py-4 border-top align-items-center">
            <div className="col-12 col-sm-6 d-flex justify-content-center justify-content-sm-start mb-3 mb-sm-0">
              <img
                src={gatwayIcon}
                alt="payment_option"
                style={{ maxWidth: "150px", width: "100%", height: "auto" }}
              />
            </div>
            <div className="col-12 col-sm-6">
              <p className="mb-0 text-center text-sm-end">
                Copyright © 2024 {branch.storeName}. All Rights Reserved. Designed By{" "}
                <a
                  tw="no-underline text-custom-100"
                  href="https://rasiinfotech.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Rasi Infotech
                </a>
              </p>
            </div>
          </div>

        </div>
      </footer>
    </>
  );
}

export default memo(Footer);